import { useI18n } from 'vue-i18n'
import { required as requiredValidator, minLength, helpers, sameAs } from '@vuelidate/validators'

// eslint-disable-next-line no-useless-escape
const emailRegex = helpers.regex(/[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]+\.[A-Za-z]{2,4}/)
const QIDStartsWith = helpers.regex(/^(2|3).*$/)

export const useValidators = () => {
  const { t } = useI18n()
  const { withMessage } = helpers

  const required = withMessage(t('qic.error.fill_field'), requiredValidator)
  const destinationValidator = withMessage(t('select_country_error'), required)
  const residenceCountryValidator = withMessage(t('select_country_error'), required)
  const emailValidator = {
    required,
    regex: withMessage(t('qic.error.email.format'), emailRegex),
  }
  const phoneValidator = {
    required,
    sameAs: withMessage(t('qic.error.phone.format'), sameAs(true)),
  }

  const emiratesIdValidator = {
    required,
    minLength: withMessage(t('qic.error.qid.consist_11_digits'), minLength(11)),
    startsWith: withMessage(t('qic.error.qid.start_with_2_3'), QIDStartsWith),
  }

  return {
    destinationValidator,
    residenceCountryValidator,
    emailValidator,
    phoneValidator,
    emiratesIdValidator,
    required,
  }
}
